// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__jnb-T","Disclaimer":"styles_Disclaimer__h90rI"};